import {
  Tooltip,
  IconButton,
  Button,
  Typography,
  Grid,
  Checkbox,
  FormControlLabel, TextField,
} from "@mui/material";
import { FormikProvider, FieldArray } from "formik";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import React, { useContext, useEffect, useMemo, useState } from "react";
import useOperationTranslation from "../../hooks/useOperationTranslation";
import { ContextOperation } from "../../context/OperationContext";
import useSnackbar from "../../hooks/useSnackbar";
import TransferReasonService from "./TransferReasonService";
import AutoComplete, { AutoCompleteOption } from "../common/AutoComplete";
import { nameof } from "../common/ObjectUtils";
import Manipulate from "./AutocompleteManipulateValues";

interface Props {
  formik: any;
  navigateBack: () => void;
  setPage: (value: boolean) => void;
  updateDatasourceAcriss: () => void;
  tenant: string;
  //setIsCheck: (value: boolean) => void;
  isCheck: boolean;
  changeTransportationType: boolean;
}

const DriverAddPage = (props: Props) => {
  const manipulate = Manipulate();
  const { setLoading, userLocations, allLocations } = useContext(ContextOperation);
  const [drivers, setDrivers] = useState<AutoCompleteOption[]>([]);
  const [shopRepairLmsList, setShopRepairLmsList] = useState<AutoCompleteOption[]>([]);
  const snackbar = useSnackbar();
  const t = useOperationTranslation();

  const disableButton = () => {
    if ((props.formik.values.driversId[0] !== "" && (props.formik.values.transferReasonCode ==='TFFICT' || !!props.formik.values.shopRepairLms)) || props.isCheck)
      return false;
    else
      return true;
  };

  const createTransferRequest = () => {
    const shopRepairLms = props.formik.values.shopRepairLms?.split('-');
    delete props.formik.values.shopRepairLms;

    const arrayManipulateDrivers = props.formik.values.driversId.filter(Number);
    const arrayManipulatePlates = props.formik.values.plates.filter(
      (str: any) => str !== ""
    );
    const data = {
      ...props.formik.values,
      driversId: arrayManipulateDrivers,
      plates: arrayManipulatePlates,
      startStationType: userLocations.find(element => element.bpCode === props.formik.values.startStationId)?.typeEnum || null,
      expectedEndStationType: allLocations.find(element => (element.bpCode === props.formik.values.expectedEndStationId && element.type === props.formik.values.expectedEndStationType))?.type || null,
      endStationType: allLocations.find(element => (element.bpCode === props.formik.values.endStationId && element.type === props.formik.values.endStationType))?.type || null,
      driverStationId: shopRepairLms?.[0],
      driverStationType: shopRepairLms?.[1]
    };

    if (props.formik.values.id === "") {
      setLoading(true);
      TransferReasonService.put
        .createTransferReason(props.tenant, data)
        .then(() => {
          props.setPage(false);
          props.updateDatasourceAcriss();
          setLoading(false);
          snackbar.show("success", t("transferReason.messages.successCreate"));
        })
        .catch((reject) => {
          setLoading(false);

          const subCode = reject?.response.data.subCode;

          if (subCode === 3) {

            snackbar.show("warning", t("transferReason.messages.errorCreateConflictingRequests"));

          } else {

            snackbar.show("error", t("transferReason.messages.errorCreate"));

          }

        });
    } else {
      setLoading(true);
      TransferReasonService.put
        .editTransferReason(props.formik.values.id, data)
        .then(() => {
          props.setPage(false);
          props.updateDatasourceAcriss();
          setLoading(false);
          snackbar.show("success", t("transferReason.messages.successEdit"));
        })
        .catch(() => {
          setLoading(false);
          snackbar.show("error", t("transferReason.messages.errorEdit"));
        });
    }
  };

  const closeModal = () => {
    props.setPage(false);
  };

  const removeField = (index: any) => {
    props.formik.values.driversId.splice(index, 1);
    if (props.formik.values.driversId.length === 0) {
      props.formik.values.driversId = [""];
    }
  };

  const saveDrivers = () => {};

  useEffect(() => {
    manipulate.getDrivers(props.tenant).then((response) => {
      setDrivers(response);
    });

    manipulate
        .getLocationsByFilters({
          tenant: props.tenant,
          type: ["LMS", "SHOP_REPAIR"],
          pageNumber: 0,
          pageSize: 1000000,
        })
        .then((response) => {
          setShopRepairLmsList(response);
        });
  }, [props.tenant]);

  useMemo(() => {
    if (props.isCheck === true) props.formik.values.driversId = [""];
  }, [props.isCheck]);

  useMemo(() => {
    if (props.changeTransportationType === true) {
      props.formik.setFieldValue(nameof<any>(`driversId`), [""]);
      //props.setIsCheck(false);
    }
  }, [props.formik.values.transferType]);

  return (
    <React.Fragment>
      <Grid container alignItems={"center"}>
        <Grid item lg={7.9}>
          <Typography variant="bodySmall" fontWeight={700}>
            {t("transferReason.details.tab4.internalDriver")}
          </Typography>
        </Grid>
        {/* <Grid item lg={4.1}>
          <FormControlLabel
            checked={props.isCheck}
            value="external"
            control={<Checkbox color="accent" />}
            label={
              <Typography variant="bodySmall" fontWeight={700}>
                {t("transferReason.details.tab4.externalDriver")}
              </Typography>
            }
            labelPlacement="start"
            onChange={(e: any) => props.setIsCheck(e.target.checked)}
          />
        </Grid> */}
      </Grid>

      <Grid container>
        <Grid container direction="row">
          <Grid item lg={8}>
            <FormikProvider value={props.formik}>
              <FieldArray
                name="driversId"
                render={(arrayHelpers: any) => (
                  <div>
                    <Grid container columns={12} rowGap={5.5} spacing={2}>
                      {props?.formik?.values?.driversId?.map(
                        (element: any, index: number) => (
                          <>
                            <Grid item xl={5} lg={5}>
                              <AutoComplete
                                fullWidth
                                label={t("transferReason.add.driverBpCode")}
                                value={props.formik.values.driversId[index]}
                                options={drivers}
                                disabled={props.isCheck}
                                onChange={(value: any) => {
                                  if (value !== undefined) {
                                    props.formik.setFieldValue(
                                      nameof<any>(`driversId[${index}]`),
                                      value
                                    );
                                  } else {
                                    removeField(index);
                                    props.formik.setFieldValue();
                                  }
                                }}
                              />
                            </Grid>

                            {/*{props.formik.values.driversId.length - 1 ==*/}
                            {/*  index && (*/}
                            {/*  <Grid item xl={2} lg={2}>*/}
                            {/*    <Tooltip title={t("tooltipTitle.add")}>*/}
                            {/*      <IconButton*/}
                            {/*        color="accent"*/}
                            {/*        disabled={*/}
                            {/*          props.formik.values.driversId[index] !==*/}
                            {/*          ""*/}
                            {/*            ? false*/}
                            {/*            : true*/}
                            {/*        }*/}
                            {/*        onClick={() => {*/}
                            {/*          arrayHelpers.push("");*/}
                            {/*        }}*/}
                            {/*      >*/}
                            {/*        <AddCircleOutlineIcon fontSize="large" />*/}
                            {/*      </IconButton>*/}
                            {/*    </Tooltip>*/}
                            {/*  </Grid>*/}
                            {/*)}*/}
                          </>
                        )
                      )}

                      <Grid item xl={5} lg={5}>
                        <AutoComplete
                            fullWidth
                            label={t("transferReason.add.shopRepairLms")}
                            value={props.formik.values.shopRepairLms}
                            options={shopRepairLmsList}
                            disabled={props.isCheck}
                            onChange={(value: any) => {
                              props.formik.setFieldValue('shopRepairLms', value);
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={t("transferReason.add.shopRepairLms")}
                                    variant={"standard"}
                                    fullWidth={true}
                                    InputLabelProps={{
                                      sx: {
                                        fontSize: '1.15rem', // Aumenta la dimensione del label
                                      }
                                    }}
                                />
                            )}
                        />
                      </Grid>
                    </Grid>
                  </div>
                )}
              />
            </FormikProvider>
          </Grid>
          {/* <Grid item lg={4} alignContent={"center"}>
            <Typography>{t("transferReason.messages.external")}</Typography>
          </Grid> */}
        </Grid>
        <Grid item lg={12}>
          <Grid container direction="row" justifyContent="flex-end" spacing={2}>
            <Grid item>
              <Button
                sx={{
                  maxWidth: "246px",
                  maxHeight: "48px",
                  minWidth: "246px",
                  minHeight: "48px",
                }}
                variant="outlined"
                onClick={
                  props.formik.values.id == "" ? props.navigateBack : closeModal
                }
              >
                <Typography
                  color={"accent"}
                  fontWeight={700}
                  variant="subtitle1"
                >
                  {props.formik.values.id == ""
                    ? t("transferReason.navigation.back")
                    : t("actionButtons.cancel")}
                </Typography>
              </Button>
            </Grid>
            <Grid item>
              <Button
                sx={{
                  maxWidth: "246px",
                  maxHeight: "48px",
                  minWidth: "246px",
                  minHeight: "48px",
                }}
                type="submit"
                form="transfer-reason"
                disabled={disableButton()}
                variant="contained"
                color="accent"
                onClick={
                  props.formik.values.id == ""
                    ? createTransferRequest
                    : saveDrivers
                }
              >
                <Typography
                  color={"white"}
                  fontWeight={700}
                  variant="subtitle1"
                >
                  {props.formik.values.id == ""
                    ? t("transferReason.add.createTransferRequest")
                    : t("actionButtons.save")}
                </Typography>
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};

export default DriverAddPage;
